import React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const testimonials = [
  {
    company: "SME Manufacturer",
    industry: "Manufacturing",
    quote:
      "L.T.I. Consulting transformed our procurement process, reducing costs by 18% in the first year while significantly improving supplier relationships. Ludvik's strategic approach and hands-on support made all the difference.",
    author: "Operations Director",
  },
  {
    company: "F&B Chain",
    industry: "Food & Beverage",
    quote:
      "Working with Ludvik has been exceptional. His expertise in digital procurement helped us modernize our entire supply chain management system. The efficiency gains have been remarkable, and the implementation was seamless.",
    author: "Chief Operating Officer",
  },
  {
    company: "Tech Startup",
    industry: "Technology",
    quote:
      "As a growing startup, we needed procurement expertise without the overhead of a full-time hire. L.T.I. Consulting provided exactly that - strategic guidance when we needed it, helping us establish robust processes from day one.",
    author: "CEO & Founder",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Trusted by Leading SMEs
          </h2>
          <p className="text-xl text-gray-600">
            See how we've helped businesses like yours achieve procurement
            excellence
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.company}
              className="border-2 border-gray-100 hover:border-[#1e3a8a] transition-all duration-300 hover:shadow-xl"
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="mb-6">
                  <Quote className="w-10 h-10 text-[#1e3a8a] opacity-50" />
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.quote}"
                </p>

                {/* Author Info */}
                <div className="border-t-2 border-gray-100 pt-6">
                  <p className="font-semibold text-gray-900 mb-1">
                    {testimonial.author}
                  </p>
                  <p className="text-[#1e3a8a] font-medium">
                    {testimonial.company}
                  </p>
                  <p className="text-sm text-gray-500">
                    {testimonial.industry}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-8 flex-wrap justify-center">
            <div className="text-center">
              <p className="text-3xl font-bold text-[#1e3a8a]">10+</p>
              <p className="text-gray-600 text-sm">Years Experience</p>
            </div>
            <div className="w-px h-12 bg-gray-200 hidden sm:block"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-[#1e3a8a]">50+</p>
              <p className="text-gray-600 text-sm">Projects Completed</p>
            </div>
            <div className="w-px h-12 bg-gray-200 hidden sm:block"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-[#1e3a8a]">100%</p>
              <p className="text-gray-600 text-sm">Client Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};